

// @mui material components
import Grid from "@mui/material/Grid";
import MDBox from "../../../../../components/MDBox";
import FormField from "../../../../../components/FormField";
import React from "react";
import MDTypography from "../../../../../components/MDTypography";
// Material Dashboard 2 PRO React components


function NewPatientForm({formData, doctors}) {

    const {formField, values, errors, touched} = formData;

    const {name, last_name, mother_last_name, email, phone, comments} = formField;
    const {
        name: nameV,
        last_name: lastNameV,
        mother_last_name: motherLastNameV,
        email: emailV,
        phone: phoneV,
        comments: commentsV,
    } = values;

    return (
        <MDBox>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                    <FormField
                        type={last_name.type}
                        label={last_name.label}
                        name={last_name.name}
                        value={lastNameV}
                        error={errors.last_name && touched.last_name}
                        success={lastNameV && lastNameV.length > 0 && !errors.last_name}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormField
                        type={mother_last_name.type}
                        label={mother_last_name.label}
                        name={mother_last_name.name}
                        value={motherLastNameV}
                        error={errors.mother_last_name && touched.mother_last_name}
                        success={motherLastNameV && motherLastNameV.length > 0 && !errors.mother_last_name}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormField
                        type={name.type}
                        label={name.label}
                        name={name.name}
                        value={nameV}
                        error={errors.name && touched.name}
                        success={nameV && nameV.length > 0 && !errors.name}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={email.type}
                        label={email.label}
                        name={email.name}
                        value={emailV}
                        error={errors.email && touched.email}
                        success={emailV && emailV.length > 0 && !errors.email}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={phone.type}
                        label={phone.label}
                        name={phone.name}
                        value={phoneV}
                        error={errors.phone && touched.phone}
                        success={phoneV && phoneV.length > 0 && !errors.phone}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={comments.type}
                        label={comments.label}
                        name={comments.name}
                        value={commentsV}
                        error={errors.comments && touched.comments}
                        success={commentsV && commentsV.length > 0 && !errors.comments}
                        {...comments}
                    />
                </Grid>
            </Grid>
        </MDBox>
    );
}

export default NewPatientForm;
